<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Sonstiges",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="SonstigesList"></CMSSinglePage>
</template>

<style scoped>

</style>
